import { useEffect, useRef, useState } from 'react';

export function useRefreshFlash(nonce: number, durationMs = 450): boolean {
	const [isRefreshing, setIsRefreshing] = useState(false);
	const isFirstRun = useRef(true);

	useEffect(() => {
		if (isFirstRun.current) {
			isFirstRun.current = false;
			return;
		}
		setIsRefreshing(true);
		const timeoutId = setTimeout(() => setIsRefreshing(false), durationMs);
		return () => clearTimeout(timeoutId);
	}, [nonce, durationMs]);

	return isRefreshing;
}
